import { ExitIntentAreas, TriggerType } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface AtLeastOneExitIntentRequiredRuleDto {
  selectedTriggers: TriggerType[];
  exitIntentAreas: ExitIntentAreas[];
}

export const AtLeastOneExitIntentRequiredRuleKey = 'atLeastOneExitIntentRequired';

export const AtLeastOneExitIntentRequiredRule = (dto: AtLeastOneExitIntentRequiredRuleDto): DomainRule => {
  if (!dto.selectedTriggers.find(s => s === TriggerType.ExitIntent)) {
    return {
      result: 'pass',
      ruleKey: undefined,
    };
  }

  if (!dto.exitIntentAreas || dto.exitIntentAreas.length < 1) {
    return {
      result: 'fail',
      ruleKey: AtLeastOneExitIntentRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
